import React, { ReactNode } from 'react';
import { Text } from '..';
import { colorSet } from '@theme';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { styleConstant, ToastTypeEnum } from '@constant';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const ToastContainer = styled.div<{ isVisible: boolean; toastType: ToastTypeEnum }>`
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 16px;
  border-radius: 12px;
  background-color: ${({ toastType }) => (toastType === ToastTypeEnum.DEFAULT ? colorSet.black : colorSet.errorMain)};
  color: white;
  animation: ${({ isVisible }) => (isVisible ? fadeIn : fadeOut)} 0.3s ease-in-out forwards;
  z-index: ${styleConstant.zIndexToast};
  will-change: transform, opacity;
`;

interface ToastProps {
  isVisible: boolean;
  toastType?: ToastTypeEnum;
  message: string | ReactNode;
  style?: React.CSSProperties;
}

export const Toast: React.FC<ToastProps> = ({ isVisible, message, style, toastType = ToastTypeEnum.DEFAULT }) => {
  return (
    <ToastContainer isVisible={isVisible} style={style} toastType={toastType}>
      {typeof message === 'string' ? (
        <Text variant="body1" color="white">
          {message}
        </Text>
      ) : (
        message
      )}
    </ToastContainer>
  );
};
